const state = {
};

const actions = {
};

const mutations = {
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/common.js